import type { ReactNode } from "react";
import { cn } from "../../lib/cn";

type Tone = "neutral" | "positive" | "muted";

const VALUE_TONE: Record<Tone, string> = {
	neutral: "text-slate-100",
	positive: "text-emerald-300",
	muted: "text-slate-400",
};

interface KpiProps {
	label: string;
	value: ReactNode;
	hint?: ReactNode;
	tone?: Tone;
}

/** Small metric card used by every dashboard section. */
export function Kpi({ label, value, hint, tone = "neutral" }: KpiProps) {
	return (
		<div className="rounded-lg border border-slate-800 bg-slate-900/40 p-4">
			<p className="text-xs uppercase tracking-wide text-slate-400">{label}</p>
			<p className={cn("mt-1 text-2xl font-semibold", VALUE_TONE[tone])}>
				{value}
			</p>
			{hint && <p className="mt-1 text-xs text-slate-400">{hint}</p>}
		</div>
	);
}
